export default "__VITE_ASSET__bfyShPCr__"